import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LayoutModule } from './layout/layout.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, LayoutModule, HttpClientModule],
  declarations: [],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, LayoutModule, HttpClientModule]
})
export class SharedModule { }
